export function hasOwnProperty(obj, prop) {
    return obj.hasOwnProperty(prop);
}
